import React from "react";
import PropTypes from "prop-types";

const CurrencyContext = React.createContext({ currency: null });

export const useCurrencyContext = () => React.useContext(CurrencyContext);

function CurrencyProvider(props) {
  return <CurrencyContext.Provider value={{ currency: props.currency }}>{props.children}</CurrencyContext.Provider>;
}

CurrencyProvider.propTypes = {
  currency: PropTypes.string,
};

export default CurrencyProvider;
